import { getAccessCondition, getUserDetails } from "../utils/auth";

//user

export const userAddAcess = () => {
  const accessCategory = getAccessCondition() || [];
  const accessDetails = accessCategory?.access_details;
  const userDetails = getUserDetails() || [];

  if (userDetails.role === "other_user") {
    const userPermissions = accessDetails?.user || [];
    if (userPermissions.includes("add")) {
      return true;
    }
    return false;
  }
  return true;
};

export const userEdit = () => {
  const accessCategory = getAccessCondition() || [];
  const accessDetails = accessCategory?.access_details;
  const userDetails = getUserDetails() || [];

  if (userDetails.role === "other_user") {
    const userPermissions = accessDetails?.user || [];
    if (userPermissions.includes("edit")) {
      return true;
    }
    return false;
  }
  return true;
};

export const userStatus = () => {
  const accessCategory = getAccessCondition() || [];
  const accessDetails = accessCategory?.access_details;
  const userDetails = getUserDetails() || [];

  if (userDetails.role === "other_user") {
    const userPermissions = accessDetails.user || [];
    if (userPermissions.includes("active_deactive")) {
      return true;
    }
    return false;
  }
  return true;
};

// Group

export const groupAdd = () => {
  const accessCategory = getAccessCondition() || [];
  const accessDetails = accessCategory?.access_details;
  const userDetails = getUserDetails() || [];

  if (userDetails.role === "other_user") {
    const userPermissions = accessDetails?.group || [];
    if (userPermissions.includes("add")) {
      return true;
    }
    return false;
  }
  return true;
};

export const groupEdit = () => {
  const accessCategory = getAccessCondition() || [];
  const accessDetails = accessCategory?.access_details;
  const userDetails = getUserDetails() || [];

  if (userDetails.role === "other_user") {
    const userPermissions = accessDetails?.group || [];
    if (userPermissions.includes("edit")) {
      return true;
    }
    return false;
  }
  return true;
};

export const groupStatus = () => {
  const accessCategory = getAccessCondition() || [];
  const accessDetails = accessCategory?.access_details;
  const userDetails = getUserDetails() || [];

  if (userDetails.role === "other_user") {
    const userPermissions = accessDetails?.group || [];
    if (userPermissions.includes("active_deactive")) {
      return true;
    }
    return false;
  }
  return true;
};

//Channels
export const channelAdd = () => {
  const accessCategory = getAccessCondition() || [];
  const accessDetails = accessCategory?.access_details;
  const userDetails = getUserDetails() || [];

  if (userDetails.role === "other_user") {
    const userPermissions = accessDetails?.channel || [];
    if (userPermissions.includes("add")) {
      return true;
    }
    return false;
  }
  return true;
};

export const channelEdit = () => {
  const accessCategory = getAccessCondition() || [];
  const accessDetails = accessCategory?.access_details;
  const userDetails = getUserDetails() || [];

  if (userDetails.role === "other_user") {
    const userPermissions = accessDetails?.channel || [];
    if (userPermissions.includes("edit")) {
      return true;
    }
    return false;
  }
  return true;
};

export const channelStatus = () => {
  const accessCategory = getAccessCondition() || [];
  const accessDetails = accessCategory?.access_details;
  const userDetails = getUserDetails() || [];

  if (userDetails.role === "other_user") {
    const userPermissions = accessDetails?.channel || [];
    if (userPermissions.includes("active_deactive")) {
      return true;
    }
    return false;
  }
  return true;
};
